import { useStore } from '@betgames/bg-state-manager';
import { GamificationNotificationType, gamificationSelectors, gamificationStore } from '@bg-shared';
import { useMemo } from 'react';
import { IMessage } from '../interfaces';

export const useUnreadMessages = (): IMessage[] => {
    const unreadInboxes = useStore(gamificationStore, gamificationSelectors.getUnSeenInboxes);
    const unreadAchievements = useStore(
        gamificationStore,
        gamificationSelectors.getUnSeenAchievements,
    );

    const unreadMessages: IMessage[] = useMemo(
        (): IMessage[] => [
            ...unreadAchievements.map((item) => ({
                ...item,
                type: GamificationNotificationType.CHALLENGE,
                title: item.name,
            })),
            ...unreadInboxes.map((item) => ({
                ...item,
                type: GamificationNotificationType.EMAIL,
            })),
        ],
        [unreadAchievements.length, unreadInboxes.length],
    );

    return unreadMessages;
};
